import $ from 'jquery';

const resetTotalAllocation = dependantParent => {
    const $dependantId = $(`#${dependantParent}`);
    const display = $dependantId.find('span.total-allocation');
    const hidden = $dependantId.find('input.total-allocation');
    display.text(0);
    hidden.val(0);
};

export default resetTotalAllocation;
